'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { createSelectorMemoized } from '@base-ui/utils/store';
import { useEventCalendarView } from '@mui/x-scheduler-internals/use-event-calendar-view';
import { processDate } from '@mui/x-scheduler-internals/process-date';
import { schedulerOtherSelectors } from '@mui/x-scheduler-internals/scheduler-selectors';
import { DayTimeGrid } from "../internals/components/day-time-grid/DayTimeGrid.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const DAY_VIEW_CONFIG = {
  siblingVisibleDateGetter: ({
    state,
    delta
  }) => state.adapter.addDays(schedulerOtherSelectors.visibleDate(state), delta),
  visibleDaysSelector: createSelectorMemoized(schedulerOtherSelectors.visibleDate, state => state.adapter, (visibleDate, adapter) => [processDate(visibleDate, adapter)])
};

/**
 * A Day View to use inside the Event Calendar.
 */
export const DayView = /*#__PURE__*/React.memo(/*#__PURE__*/React.forwardRef(function DayView(props, forwardedRef) {
  // Feature hooks
  const {
    days
  } = useEventCalendarView(DAY_VIEW_CONFIG);
  return /*#__PURE__*/_jsx(DayTimeGrid, _extends({
    ref: forwardedRef,
    days: days
  }, props));
}));
if (process.env.NODE_ENV !== "production") DayView.displayName = "DayView";